export default {
  en: {
    title: 'Terms of Service',
    updated: 'September 11, 2026',
    sections: [
      {
        heading: '1. Agreement',
        paragraphs: [
          'These Terms of Service ("Terms") govern your access to and use of SocialLabs ("Service"), operated by CodeLabs. By creating an account or using the Service, you agree to these Terms.',
        ],
      },
      {
        heading: '2. The Service',
        paragraphs: [
          'SocialLabs provides a design studio, social media scheduling, AI-assisted content tools, analytics, storage, and related integrations (including Instagram/Meta, Google sign-in, and payment providers).',
          'We may update, suspend, or discontinue features at any time. Beta or experimental features may be offered without warranty.',
        ],
      },
      {
        heading: '3. Accounts',
        paragraphs: [
          'You must provide accurate registration information and keep your credentials secure. You are responsible for all activity under your account.',
          'You must be at least 18 years old, or the age of majority in your jurisdiction, to use paid features.',
        ],
      },
      {
        heading: '4. Acceptable Use',
        paragraphs: [
          'You may not use the Service to violate laws, infringe intellectual property, distribute malware, spam, harass others, or attempt unauthorized access.',
          'You are solely responsible for content you create, upload, schedule, or publish through connected social accounts.',
          'You must comply with the terms and policies of third-party platforms (e.g. Meta/Instagram, Google, PayPal, local payment providers).',
        ],
      },
      {
        heading: '5. Subscriptions & Billing',
        paragraphs: [
          'Paid plans renew according to the billing cycle shown at checkout unless cancelled. Prices may change with reasonable notice.',
          'Payments are processed by third-party providers (PayPal, QRIS & Virtual Account). We do not store full payment card details.',
          'All payments are final and non-refundable. See our Refund Policy. Failure to pay may result in downgrade or suspension.',
        ],
      },
      {
        heading: '6. Intellectual Property',
        paragraphs: [
          'SocialLabs, its branding, software, and documentation remain our property or our licensors\' property.',
          'You retain ownership of your content. You grant us a limited license to host, process, and display your content solely to operate the Service.',
        ],
      },
      {
        heading: '7. Third-Party Services',
        paragraphs: [
          'Integrations with external services are provided "as is". We are not responsible for outages, policy changes, or actions taken by third parties.',
          'Disconnecting an integration may limit functionality.',
        ],
      },
      {
        heading: '8. Disclaimer & Limitation of Liability',
        paragraphs: [
          'The Service is provided "as is" and "as available" without warranties of any kind, to the fullest extent permitted by law.',
          'We are not liable for indirect, incidental, special, or consequential damages, or loss of profits, data, or goodwill arising from your use of the Service.',
          'Our total liability for any claim is limited to the amount you paid us in the twelve (12) months before the claim, or USD $100 if you use a free plan.',
        ],
      },
      {
        heading: '9. Termination',
        paragraphs: [
          'You may stop using the Service at any time. We may suspend or terminate accounts that violate these Terms or pose risk to the Service or other users.',
          'Upon termination, your right to use the Service ends. Provisions that should survive termination will remain in effect.',
        ],
      },
      {
        heading: '10. Governing Law & Contact',
        paragraphs: [
          'These Terms are governed by the laws of Indonesia, without regard to conflict-of-law rules.',
          'Questions about these Terms: contact@codelabs.id',
        ],
      },
    ],
  },
  id: {
    title: 'Syarat & Ketentuan',
    updated: '11 September 2026',
    sections: [
      {
        heading: '1. Perjanjian',
        paragraphs: [
          'Syarat & Ketentuan ini ("Ketentuan") mengatur akses dan penggunaan Anda atas SocialLabs ("Layanan"), yang dioperasikan oleh CodeLabs. Dengan membuat akun atau menggunakan Layanan, Anda menyetujui Ketentuan ini.',
        ],
      },
      {
        heading: '2. Layanan',
        paragraphs: [
          'SocialLabs menyediakan design studio, penjadwalan media sosial, alat konten berbantuan AI, analitik, penyimpanan, dan integrasi terkait (termasuk Instagram/Meta, masuk Google, dan penyedia pembayaran).',
          'Kami dapat memperbarui, menangguhkan, atau menghentikan fitur sewaktu-waktu. Fitur beta atau eksperimental dapat ditawarkan tanpa jaminan.',
        ],
      },
      {
        heading: '3. Akun',
        paragraphs: [
          'Anda wajib memberikan informasi pendaftaran yang akurat dan menjaga keamanan kredensial. Anda bertanggung jawab atas seluruh aktivitas di akun Anda.',
          'Anda harus berusia minimal 18 tahun, atau usia dewasa menurut hukum yang berlaku, untuk menggunakan fitur berbayar.',
        ],
      },
      {
        heading: '4. Penggunaan yang Diperbolehkan',
        paragraphs: [
          'Anda dilarang menggunakan Layanan untuk melanggar hukum, melanggar hak kekayaan intelektual, menyebarkan malware, spam, melecehkan orang lain, atau mencoba akses tanpa izin.',
          'Anda sepenuhnya bertanggung jawab atas konten yang dibuat, diunggah, dijadwalkan, atau dipublikasikan melalui akun sosial yang terhubung.',
          'Anda harus mematuhi ketentuan dan kebijakan platform pihak ketiga (mis. Meta/Instagram, Google, PayPal, penyedia pembayaran lokal).',
        ],
      },
      {
        heading: '5. Langganan & Pembayaran',
        paragraphs: [
          'Paket berbayar diperpanjang sesuai siklus tagihan saat checkout kecuali dibatalkan. Harga dapat berubah dengan pemberitahuan wajar.',
          'Pembayaran diproses oleh penyedia pihak ketiga (PayPal, QRIS & Virtual Account). Kami tidak menyimpan detail kartu pembayaran lengkap.',
          'Semua pembayaran bersifat final dan tidak dapat dikembalikan. Lihat Kebijakan Pengembalian Dana. Kegagalan bayar dapat mengakibatkan penurunan paket atau penangguhan.',
        ],
      },
      {
        heading: '6. Hak Kekayaan Intelektual',
        paragraphs: [
          'SocialLabs, merek, perangkat lunak, dan dokumentasinya tetap menjadi milik kami atau pemberi lisensi.',
          'Anda mempertahankan kepemilikan konten Anda. Anda memberi kami lisensi terbatas untuk menghosting, memproses, dan menampilkan konten hanya untuk mengoperasikan Layanan.',
        ],
      },
      {
        heading: '7. Layanan Pihak Ketiga',
        paragraphs: [
          'Integrasi dengan layanan eksternal disediakan "apa adanya". Kami tidak bertanggung jawab atas gangguan, perubahan kebijakan, atau tindakan pihak ketiga.',
          'Memutus integrasi dapat membatasi fungsionalitas.',
        ],
      },
      {
        heading: '8. Penafian & Batasan Tanggung Jawab',
        paragraphs: [
          'Layanan disediakan "apa adanya" dan "sebagaimana tersedia" tanpa jaminan apa pun, sejauh diizinkan hukum.',
          'Kami tidak bertanggung jawab atas kerugian tidak langsung, insidental, khusus, atau konsekuensial, atau hilangnya keuntungan, data, atau goodwill akibat penggunaan Layanan.',
          'Total tanggung jawab kami untuk setiap klaim dibatasi pada jumlah yang Anda bayarkan dalam dua belas (12) bulan sebelum klaim, atau USD $100 jika Anda memakai paket gratis.',
        ],
      },
      {
        heading: '9. Penghentian',
        paragraphs: [
          'Anda dapat berhenti menggunakan Layanan kapan saja. Kami dapat menangguhkan atau menghentikan akun yang melanggar Ketentuan atau membahayakan Layanan atau pengguna lain.',
          'Setelah penghentian, hak Anda menggunakan Layanan berakhir. Ketentuan yang seharusnya tetap berlaku akan tetap berlaku.',
        ],
      },
      {
        heading: '10. Hukum yang Berlaku & Kontak',
        paragraphs: [
          'Ketentuan ini diatur oleh hukum Indonesia, tanpa memperhatikan aturan konflik hukum.',
          'Pertanyaan tentang Ketentuan ini: contact@codelabs.id',
        ],
      },
    ],
  },
}
